var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftWithoutSize = function SvgArrowLeftWithoutSize(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11859_181140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.416 15.834-5.691-5.692 5.691-5.691a.78.78 0 0 0 .234-.559.78.78 0 0 0-.234-.558.78.78 0 0 0-1.108 0l-6.25 6.25a.77.77 0 0 0-.225.558c0 .209.083.409.225.55l6.25 6.242a.78.78 0 0 0 1.108 0 .8.8 0 0 0 .234-.55.76.76 0 0 0-.234-.55"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11859_181140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.833 3.11h7.817v14.057H5.833z"
  })))));
};
export default SvgArrowLeftWithoutSize;